<template>
  <div class="main" id="search">
    <div class="search">
      <a @click="returnHome" class="return">
      </a>
      <input v-model="keyword" type="text" placeholder="视频关键字"/>
      <button type="button" class="search-btn" @click="searchVod(1)">搜索</button>
    </div>

    <div v-if="searched === false" class="mt25">
      <div class="hot-search">
        <h3 class="h">搜索历史<a href="#"></a></h3>
        <ul>
          <li v-for="(item, index) in hisWords" :key="index" @click="quickSearch(item)">{{item}}</li>
        </ul>
      </div>
    </div>

    <div v-else class="search-ls">
      <h3 class="h3">搜索结果：</h3>
      <vod-list :show-title="false" :vodData="list"></vod-list>
      
    </div>
    
    <loading ref="loading" scroll-div="search" :is-loading="isLoading" :is-no-more-data="isNoMoreData" @get-books="searchVod(page + 1)"></loading>
    <alert :show="showAlert" :msg="alertMsg" @hided="showAlert = false"></alert>

    <vodBottom></vodBottom>
    
  </div>
</template>

<script>
  import VodList from '@/components/share/vod-list.vue'
  import Alert from '../../components/share/alert';
  import Loading from "../../components/share/loading";
  import searchService from "../../services/searchService";
  import vodBottom from '@/components/layer1/bottomIndex'
  import userService from "../../services/userService";
  
  export default {
    name: "search-vod",
    data() {
      return {
        componentName: '',
        searched: false,
        alertMsg: '',
        showAlert: false,
        hisWords: '',
        keyword: '',
        page: 1,
        nextPage: false,
        list: [],
        isLoading: false,
        isNoMoreData: false,
      }
    },
    methods: {
      returnHome() {
        this.$router.isBack = false;
        this.$router.push('/vod');
      },

      searchVod(page){
        this.page = page

        if (this.keyword === ''){
          this.alertMsg = "请输入搜索关键字";
          this.showAlert = true;
        }else if(this.keyword.length > 20){
          this.alertMsg = "搜索关键字最长不超过20个字";
          this.showAlert = true;
        }else {
          this.searched = true;
          this.hisWords = searchService.setVodHistorySearch(this.keyword);

          this.isLoading = true;
          this.isNoMoreData = false;

          searchService.searchVod(this.keyword, this.page).then(res => {
            if (res.data){
              this.isLoading = false;
              if (res.data.length === 0) {
                this.isNoMoreData = true;
                this.nextPage = false
                if (this.page === 1) {this.list = []}
              } else if (this.page === 1) {
                this.list = res.data;
                this.nextPage =  this.list.length >= 20 ? true :false
              } else if (this.page > 1) {
                this.list.push(...res.data);
              }
            }
            setTimeout(() => {
              this.$refs['loading'].scrollFunction();
            }, 0)
            
          });
        }
      },
      quickSearch(content) {
        this.keyword = content;
        this.searchVod(1);
      }
    },
    components: {
      'vod-list': VodList,
      alert: Alert,
      loading: Loading,
      vodBottom: vodBottom
    },
    mounted() {
      this.hisWords = searchService.getVodHistorySearch();
      this.componentName = this.$route.name;
      userService.getUserOrReg().then(res => {
        this.avaliableAmount = res.avaliableAmount
        this.gettingData();
      });
      if(this.$store.state.pageState[this.componentName] && this.$router.isBack) {
        Object.assign(this.$data, this.$store.state.pageState[this.$route.name].data);
        setTimeout(() => {
          let scrollDiv = document.getElementById('search');
          scrollDiv.scrollTop = this.$store.state.pageState[this.$route.name].top;
        }, 0);
      }
    },
    beforeDestroy() {
      // let scrollDiv = document.getElementById('search');
      // let state = {};
      // state[this.componentName] = {data: this.$data, top: scrollDiv.scrollTop}
      // this.$store.commit('saveState', state);
      // this.list = []
      // this.searched = false;
      // this.isNoMoreData = false;
    }
  }
</script>

<style>
  @import '../../assets/css/search.css';
</style>



// WEBPACK FOOTER //
// src/pages/layer1/search-vod.vue